/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoutedEligibilityInsuranceContext } from './RoutedEligibilityInsuranceContext';
import {
    RoutedEligibilityInsuranceContextFromJSON,
    RoutedEligibilityInsuranceContextFromJSONTyped,
    RoutedEligibilityInsuranceContextToJSON,
    RoutedEligibilityInsuranceContextToJSONTyped,
} from './RoutedEligibilityInsuranceContext';
import type { EligibilityCheckRequestObject } from './EligibilityCheckRequestObject';
import {
    EligibilityCheckRequestObjectFromJSON,
    EligibilityCheckRequestObjectFromJSONTyped,
    EligibilityCheckRequestObjectToJSON,
    EligibilityCheckRequestObjectToJSONTyped,
} from './EligibilityCheckRequestObject';

/**
 * 
 * @export
 * @interface PerformEligibilityCheckRequest
 */
export interface PerformEligibilityCheckRequest {
    /**
     * 
     */
    selected_payer_source: PerformEligibilityCheckRequestSelectedPayerSourceEnum;
    /**
     * 
     */
    selected_payer_id: string;
    /**
     * 
     */
    lead_insurance_id?: string;
    /**
     * 
     */
    insurance_context: RoutedEligibilityInsuranceContext;
    /**
     * 
     */
    eligibility_request: EligibilityCheckRequestObject;
    /**
     * 
     */
    coverage_priority: string;
    /**
     * Whether memberIdentifier is an MBI or SSN. Defaults to MBI.
     */
    member_identifier_type?: PerformEligibilityCheckRequestMemberIdentifierTypeEnum;
}


/**
 * @export
 */
export const PerformEligibilityCheckRequestSelectedPayerSourceEnum = {
    Stedi: 'stedi',
    Inovalon: 'inovalon',
} as const;
export type PerformEligibilityCheckRequestSelectedPayerSourceEnum = typeof PerformEligibilityCheckRequestSelectedPayerSourceEnum[keyof typeof PerformEligibilityCheckRequestSelectedPayerSourceEnum];

/**
 * @export
 */
export const PerformEligibilityCheckRequestMemberIdentifierTypeEnum = {
    Mbi: 'MBI',
    Ssn: 'SSN',
} as const;
export type PerformEligibilityCheckRequestMemberIdentifierTypeEnum = typeof PerformEligibilityCheckRequestMemberIdentifierTypeEnum[keyof typeof PerformEligibilityCheckRequestMemberIdentifierTypeEnum];


/**
 * Check if a given object implements the PerformEligibilityCheckRequest interface.
 */
export function instanceOfPerformEligibilityCheckRequest(value: object): value is PerformEligibilityCheckRequest {
    if (!('selected_payer_source' in value) || value['selected_payer_source'] === undefined) return false;
    if (!('selected_payer_id' in value) || value['selected_payer_id'] === undefined) return false;
    if (!('insurance_context' in value) || value['insurance_context'] === undefined) return false;
    if (!('eligibility_request' in value) || value['eligibility_request'] === undefined) return false;
    if (!('coverage_priority' in value) || value['coverage_priority'] === undefined) return false;
    return true;
}

export function PerformEligibilityCheckRequestFromJSON(json: any): PerformEligibilityCheckRequest {
    return PerformEligibilityCheckRequestFromJSONTyped(json, false);
}

export function PerformEligibilityCheckRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerformEligibilityCheckRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'selected_payer_source': json['selected_payer_source'],
        'selected_payer_id': json['selected_payer_id'],
        'lead_insurance_id': json['lead_insurance_id'] == null ? undefined : json['lead_insurance_id'],
        'insurance_context': RoutedEligibilityInsuranceContextFromJSON(json['insurance_context']),
        'eligibility_request': EligibilityCheckRequestObjectFromJSON(json['eligibility_request']),
        'coverage_priority': json['coverage_priority'],
        'member_identifier_type': json['member_identifier_type'] == null ? undefined : json['member_identifier_type'],
    };
}

export function PerformEligibilityCheckRequestToJSON(json: any): PerformEligibilityCheckRequest {
    return PerformEligibilityCheckRequestToJSONTyped(json, false);
}

export function PerformEligibilityCheckRequestToJSONTyped(value?: PerformEligibilityCheckRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selected_payer_source': value['selected_payer_source'],
        'selected_payer_id': value['selected_payer_id'],
        'lead_insurance_id': value['lead_insurance_id'],
        'insurance_context': RoutedEligibilityInsuranceContextToJSON(value['insurance_context']),
        'eligibility_request': EligibilityCheckRequestObjectToJSON(value['eligibility_request']),
        'coverage_priority': value['coverage_priority'],
        'member_identifier_type': value['member_identifier_type'],
    };
}

